<template>
    <div class="container layout">
        <top title="1 dakikada maaş bilgisi veya mülakat deneyimi paylaş, diğer paylaşımları anında keşfet!"
            :PrivacyAccordion="true"></top>
        <div class="columns is-marginless">
            <div class="column is-7">
                <div class="column is-full">
                    <div>
                        <privacy-accordion class="is-hidden-tablet"></privacy-accordion>
                    </div>
                    <div class="box form main-form">
                        <section>
                            <b-field label="Hangisini paylaşmak istiyorsun?" class="main-field">
                                <div class="is-block">
                                    <b-radio v-model="type" type="is-info" native-value="salary">
                                        Maaş Bilgisi
                                    </b-radio>
                                    <b-radio v-model="type" type="is-info" native-value="interview">
                                        Mülakat Deneyimi
                                    </b-radio>
                                </div>
                            </b-field>

                            <b-field label="Hangi işin için paylaşıyorsun?*" v-if="type === 'salary'">
                                <b-field>
                                    <b-radio-button v-model="currentJob" type="is-info" :native-value="true">
                                        <span>Mevcut İşim</span>
                                    </b-radio-button>

                                    <b-radio-button v-model="currentJob" type="is-info" :native-value="false">
                                        <span>Önceki İşim</span>
                                    </b-radio-button>
                                </b-field>
                            </b-field>

                            <b-field :label="type=='interview'?'Hangi şirket için paylaşıyorsun?*':'Hangi şirket için paylaşıyorsun?'"  
                            :type="{ 'is-danger': !company.selected && !valid && type=='interview'}"
                                :message="{ 'Bir şirket seçmelisin': !company.selected && !valid && type=='interview' }">
                                <b-autocomplete ref="companyAutocomplete" v-model="company.name" :data="company.data"
                                    placeholder="Şirket Ara" field="companyName" :loading="company.isFetching"
                                    @input="getAutoCompleteService('company')" @select="option => company.selected = option"
                                    :open-on-focus="true" icon-pack="mdi" icon="magnify">
                                </b-autocomplete>
                            </b-field>

                            <b-field label="Hangi pozisyon için paylaşıyorsun?*"
                                :type="{ 'is-danger': !position.selected && !valid }"
                                :message="{ 'Bir pozisyon seçmelisin': !position.selected && !valid }">
                                <b-autocomplete ref="positionAutocomplete" v-model="position.name" :data="position.data"
                                    placeholder="Pozisyon Ara" field="name" :loading="position.isFetching"
                                    @input="getAutoCompleteService('position')"
                                    @select="option => position.selected = option" :open-on-focus="true" icon-pack="mdi"
                                    icon="magnify">
                                </b-autocomplete>
                            </b-field>

                            <b-field label="Nerede yaşıyorsun?*" :type="{ 'is-danger': !city.selected && !valid }"
                                :message="{ 'Bir şehir seçmelisin': !city.selected && !valid }">
                                <b-autocomplete ref="cityAutocomplete" v-model="city.name" :data="city.data"
                                    placeholder="Şehir Ara" field="name" :loading="city.isFetching"
                                    @input="getAutoCompleteService('city')" @select="option => city.selected = option"
                                    :open-on-focus="true" icon-pack="mdi" icon="magnify">
                                </b-autocomplete>
                            </b-field>

                            <b-field label="Çalışma şeklin nasıl?*" :type="{ 'is-danger': !workType && !valid }"
                                :message="{ 'Çalışma şekli seçmelisin': !workType && !valid }">
                                <b-select placeholder="Çalışma Şeklini Seç" v-model="workType" required>
                                    <option value="3">Uzaktan</option>
                                    <option value="2">Hibrit</option>
                                    <option value="1">Ofis</option>
                                </b-select>
                            </b-field>

                            <div class="buttons is-centered">
                                <button class="button is-primary is-uppercase has-text-weight-semibold main-save"
                                    @click="setRedirect">Devam Et</button>
                            </div>

                        </section>
                    </div>
                </div>
            </div>
            <div class="column is-hidden-mobile">
                <privacy-accordion></privacy-accordion>
            </div>
        </div>
    </div>
</template>

<script>

import autocomplete from '@/mixins/autocomplete'

import top from '@/components/Top'
import PrivacyAccordion from '@/components/PrivacyAccordion'

export default {
    name: "Main",
    components: { PrivacyAccordion, top },
    mixins: [autocomplete],
    data() {
        return {
            valid: true,
            type: 'salary',
            currentJob: true,
            workType: null,
        }
    },
    methods: {
        formValid(params) {
            let formKeys = this.type=="interview" ?['companyId', 'positionId', 'cityId', 'workType']: ['positionId', 'cityId', 'workType'],
                formElementValid = {},
                valid

            // form valid  control
            formKeys.map(item => formElementValid[item] = Object.keys(params).indexOf(item))
            valid = !Object.values(formElementValid).includes(-1)

            return valid
        },
        setRedirect() {

            let params = {};

            if (this.company.selected) {
                params.companyId = this.company.selected.companyId;
                params.companyName = this.company.selected.companyName;
            }

            if (this.position.selected) {
                params.positionId = this.position.selected.id;
            }

            if (this.city.selected) {
                params.cityId = this.city.selected.id;
            }

            if (this.workType) {
                params.workType = this.workType;
            }

            this.valid = this.formValid(params);

            if (!this.valid) {
                // scroll top is danger
                this.$nextTick(() => {
                    document.querySelectorAll('.is-danger')[0].scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
                });
                return false
            }

            // set session information including city and worktype
            sessionStorage.setItem('userCompany', JSON.stringify(this.company.selected))
            sessionStorage.setItem('userPosition', JSON.stringify(this.position.selected))
            sessionStorage.setItem('cityId', this.city.selected.id)
            sessionStorage.setItem('city', JSON.stringify(this.city.selected))
            sessionStorage.setItem('workType', this.workType)

            // redirect to salary page
            sessionStorage.setItem('currentJob', JSON.stringify(this.currentJob))
            this.$router.push({ path: this.type });



        }
    },
    created() {
        // remove session information
        sessionStorage.removeItem('userCompany')
        sessionStorage.removeItem('userPosition')
        sessionStorage.removeItem('currentJob')
        sessionStorage.removeItem('cityId')
        sessionStorage.removeItem('city')
        sessionStorage.removeItem('workType')

    }
}
</script>
